import type { ReactNode } from 'react';
import { ChatLeftText } from 'react-bootstrap-icons';
import { Typography } from '@ghq-abi/design-system-v2';

import { cn } from '~/lib/utils';

interface ModalInfoBoxProps {
  lines: ReactNode[];
  icon?: ReactNode;
  iconContainerClassName?: string;
}

export function ModalInfoBox({
  lines,
  icon,
  iconContainerClassName
}: ModalInfoBoxProps) {
  return (
    <div className="w-full p-4 flex flex-col items-center gap-4 rounded-2xl border border-gray-200 bg-gray-50">
      {/* bg-[#FBF2B3]: amarelo âmbar claro — destaque visual neutro para ícone de informação */}
      <div
        className={cn(
          'w-16 h-16 rounded-full flex items-center justify-center',
          iconContainerClassName ?? 'bg-[#FBF2B3]'
        )}>
        {icon ?? <ChatLeftText className="w-8 h-8 text-yellow-600" />}
      </div>
      <div className="text-center flex flex-col gap-1">
        {lines.map((line, index) => (
          // eslint-disable-next-line react/no-array-index-key
          // `lines` é um array estático de mensagens informativas passado pelo pai;
          // não é reordenável nem tem identidade própria — index como key é seguro aqui.
          <Typography key={index} variant="body-sm-regular" color="light">
            {line}
          </Typography>
        ))}
      </div>
    </div>
  );
}
